import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  close() {
    document.getElementById("modal_sidebar_inner").remove();
    document.getElementById("modal_sidebar").src = "";
  }
  connect() {}
}
